import { PageContainer } from '@if/mui'
import { Stack } from '@mui/material'
import { ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ProtectionPlanCoverage } from './components/ProtectionPlanCoverage'
import { ProtectionPlanFaq } from './components/ProtectionPlanFaq'
import { ProtectionPlanHighlights } from './components/ProtectionPlanHighlights'

/**
 * The worksheet route, as a pattern. `PageContainer` matches it against the entry the
 * user actually came from, so the ids stay unknown here and back still returns to that
 * exact application's worksheet.
 */
const WORKSHEET_ROUTE = '/credits/:financingProgramId/:id/worksheet'

const ProtectionPlanPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer
      // Home stays the default parent — where a deep link or a shared URL belongs.
      // The caller's page is an alternate: reached from there, back shows its label
      // and restores it via history rather than loading it fresh.
      back={{
        to: '/',
        label: t('protectionPlan.back'),
        alternates: [{ to: WORKSHEET_ROUTE, label: t('protectionPlan.backToOrigin') }],
      }}
      overline={{ label: t('protectionPlan.overline'), variant: 'accent', icon: ShieldCheck }}
      title={t('protectionPlan.title')}
      subtitle={t('protectionPlan.subtitle')}
    >
      <Stack spacing={3}>
        <ProtectionPlanHighlights />
        <ProtectionPlanCoverage />
        <ProtectionPlanFaq />
      </Stack>
    </PageContainer>
  )
}

export default ProtectionPlanPage
